import { AppShell, Group, Title } from "@mantine/core"
import { ReactNode } from "react"
import { Link, useLocation, useNavigate } from "react-router-dom"

import { Logo } from "../../icons/logos/Logo"
import { LogoDark } from "../../icons/logos/LogoDark"

import classes from "./AppHeader.module.css"

type HeaderNavItem = {
  label: string
  link: string
}
type Props = {
  children?: ReactNode
  theme?: "supplier" | "brand"
  justify?: "space-between" | "center" | "left" | "right"
  navItems?: HeaderNavItem[]
  h?: string
}
export const AppHeader = ({
  children,
  theme = "brand",
  justify = "space-between",
  navItems,
  h = "fit-content",
  ...props
}: Props) => {
  const navigate = useNavigate()
  const location = useLocation()

  return (
    <AppShell.Header
      py="xs"
      px="md"
      h={h}
      className={classes[theme]}
      style={{
        overflow: "hidden",
      }}
      {...props}
    >
      <Group justify={justify} wrap="nowrap" w="100%" h="100%" p={0}>
        {theme === "brand" ? (
          <Link to="/" style={{ height: "inherit" }}>
            <Logo height={32} />
          </Link>
        ) : theme === "supplier" ? (
          <LogoDark
            width="100px"
            height="auto"
            className={classes["header-logo"]}
          />
        ) : null}
        {navItems ? (
          <Group
            wrap="nowrap"
            justify="right"
            gap="var(--tfg-molecule-padding-x)"
          >
            {navItems?.map((navItem, index) => (
              <Title
                className={classes.title}
                fw={500}
                fz="sm"
                key={`${navItem.label}-${index}`}
              >
                <a
                  href={navItem.link}
                  data-active={location.pathname === navItem.link || undefined}
                  onClick={(event) => {
                    event.preventDefault()
                    navigate(navItem.link)
                  }}
                >
                  {navItem.label}
                </a>
              </Title>
            ))}
          </Group>
        ) : null}
        <Group wrap="nowrap">{children}</Group>
      </Group>
    </AppShell.Header>
  )
}
